import React from 'react';
import BlockContainer from './BlockContainer';
import PropTypes from 'prop-types';
import delayIcon from './../../assets/images/typing.svg';
import './../../assets/styles/blocks/global-style.scss';

const DelayBlock = ({
  id,
  sequences,
  deleteBlock,
  copyBlock,
  moveBlock,
  saveLoader,
  hasWriteAccess,
}) => {
  return (
    <BlockContainer
      id={id}
      title='Delay'
      subtitle='This will add a delay in your Sequence'
      sequences={sequences}
      save={true}
      isLoading={saveLoader}
      icon={delayIcon}
      handleDelete={() => deleteBlock(id)}
      handleCopy={copyBlock}
      handleMove={moveBlock}
      hasWriteAccess={hasWriteAccess}
    >
      <p className='subtitle'>A delay will be added when this block triggers</p>
    </BlockContainer>
  );
};
DelayBlock.propTypes = {
  id: PropTypes.number.isRequired,
  deleteBlock: PropTypes.func.isRequired,
  saveLoader: PropTypes.bool.isRequired,
  hasWriteAccess: PropTypes.bool.isRequired,
};

DelayBlock.defaultState = {
  deleteBlock: (blockId, SequenceId) =>
    console.log('delete from default props', blockId, SequenceId),
  hasWriteAccess: false,
};

export default DelayBlock;
